import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './styles.scss';

export default function PageHeading(props) {
  return (
    <h2 className="page-heading" data-testid="header">
      {props.titlePrimary}
      <span> {props.titleSecondary}</span>
    </h2>
  );
}
PageHeading.propTypes = {
  titlePrimary: PropTypes.string,
  titleSecondary: PropTypes.string
};
